import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import { Dropdown } from "react-bootstrap";

import { ThemeContext } from "../../../context/ThemeContext";

import BalanceCardSlider from "../Dashboard/Dashboard/BalanceCardSlider";
import { LtcIcon, BtcIcon, XtzIcon, EthIcon } from "../Dashboard/SvgIcon";

import coin from "../../../assets/images/coin.png";
import BalanceCard from "./CommanPage/BalanceCard";
import {
  getWalletTransactionsSummary,
  getWalletTransactions,
  getUserAssetCategory,
  getEarnings,
} from "../../../api/walletTransaction";
import { fetchCoinsForSelect } from "../../../api/coin";
import { COIN_CATEGORIES } from "../Trading/Market";
import { usePrices } from "../../../context/SocketContext";

const AssetsChart = loadable(() =>
  pMinDelay(import("../Dashboard/Dashboard/AssetsChart"), 1000)
);

const marketBlog = [
  { icon: LtcIcon, classBg: "bg-success", Name: "LTC" },
  { icon: BtcIcon, classBg: "bg-warning", Name: "BTC" },
  { icon: XtzIcon, classBg: "bg-primary", Name: "XTZ" },
  { icon: EthIcon, classBg: "bg-pink", Name: "ETH" },
  { icon: XtzIcon, classBg: "bg-primary", Name: "XTZ" },
];

const cardTitle = [{ title: "Income" }, { title: "Outcome" }];
const COLORS = [
  "#E085E4",
  "#2A353A",
  "#C0E192",
  "#9568ff",
  "#FDB45C",
  "#4BC0C0",
];

const Portfolio = () => {
  const [coinChartData, setCoinChartData] = useState({
    series: [],
    labels: [],
  });
  const [pickerData, setPickerData] = useState([]);
  const [marketCoins, setMarketCoins] = useState([]);
  const prices = usePrices();
  const { changeBackground } = useContext(ThemeContext);
  const [earnings, setEarning] = useState({ spot: 0, future: 0 });
  const [walletSummary, setWalletSummary] = useState([]);
  const [buySummary, setBuySummary] = useState([]);
  const [sellSummary, setSellSummary] = useState([]);

  useEffect(() => {
    // Fire all independent requests in parallel
    Promise.all([
      getUserAssetCategory().catch(() => null),
      getEarnings().catch(() => null),
      getWalletTransactionsSummary().catch(() => null),
      getWalletTransactions({ type: "buy" }).catch(() => null),
      getWalletTransactions({ type: "sell" }).catch(() => null),
      fetchCoinsForSelect().catch(() => []),
    ]).then(([categoryRes, earnings, summary, buyRes, sellRes, coins]) => {
      // Chart data
      if (categoryRes?.data) {
        const { labels, series } = categoryRes.data;
        setCoinChartData({ labels, series });
        setPickerData(
          labels.map((label, idx) => ({
            datatitle: label,
            price: series[idx],
            fillcolor: COLORS[idx % COLORS.length],
          }))
        );
      }

      // Earnings
      if (earnings) {
        setEarning({ spot: earnings.spotEarnings, future: earnings.futureEarnings });
      }

      // Wallet summary
      if (summary) setWalletSummary(summary);

      // Wallet transactions
      setBuySummary(buyRes?.data?.data ?? []);
      setSellSummary(sellRes?.data?.data ?? []);

      // Coins for market
      if (coins) setMarketCoins(coins);
    }).catch((err) => console.error("Portfolio fetch error:", err));
  }, []);

  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
  }, []);
  const calcProgress = (value) =>
    Math.min(Math.max((value / 10000) * 100, 0), 100);
  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="card bubles">
                <div className="card-body">
                  <div className="buy-coin  bubles-down">
                    <div>
                      <h2>Buy & Sell 100+ Coins Instantly</h2>
                      {/* <p>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been.
                      </p> */}
                      <Link to={"/market"} className="btn btn-primary mt-2">
                        Buy Coin
                      </Link>
                    </div>
                    <div className="coin-img">
                      <img src={coin} className="img-fluid" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="">
              <BalanceCardSlider walletSummary={walletSummary} />
            </div>

            <div className="col-xl-4 market-previews col-lg-12 ">
              <div className="card">
                <div className="card-header border-0 pb-0">
                  <div>
                    <h2 className="heading">Market Previews</h2>
                  </div>
                </div>

                <div className="card-body pt-0 px-0">
                  {marketCoins.slice(0, 5).map((data, ind) => {
                    const coinPrice = prices.find(
                      (item) => item.id === coin.id
                    );
                    return (
                      <Link
                        to={`/coin-details/${data.coin.id}`}
                        className="previews-info-list"
                      >
                        <div className="pre-icon">
                          <span className="icon-box icon-box-sm">
                            <img
                              src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${data.coin.logo}`}
                              alt={data.coin.symbol}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </span>
                          <div className="ms-2">
                            <h6>{data.coin?.symbol}</h6>
                            <span>{data.coin.name}</span>
                          </div>
                        </div>
                        <div className="count">
                          <h6>{data?.transactionType}</h6>
                          <h6>
                            {(data.quantity * coinPrice?.price).toFixed(4) ||
                              Number(data.quantity * data.prices).toFixed(4)}
                          </h6>
                          <span style={{ color: coinPrice?.color }}>
                            {coinPrice?.percentChange}
                          </span>
                        </div>
                      </Link>
                    );
                  })}
                  {/* See More Text Link */}
                  <div className="card-footer text-center pt-2 border-0">
                    <Link to="/trade" className="btn-link text-black">
                      Show more <i className="fa fa-caret-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-4 assets-al col-lg-12">
              <div className="card">
                <div className="card-header border-0 pb-0">
                  <h2 className="heading">Assets Allocation</h2>
                </div>
                <div className="card-body text-center pt-0 pb-2">
                  <div id="morris_donught" className="custome-donut">
                    {coinChartData?.series?.length > 0 ? (
                      <AssetsChart
                        series={coinChartData.series}
                        labels={coinChartData.labels}
                      />
                    ) : (
                      <div className="chart-placeholder"> Loading Chart.. </div>
                    )}
                  </div>

                  <div className="chart-items">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12">
                        <div className="text-start">
                          <span className="font-w600 mb-2 d-block text-secondary fs-14">
                            Legend
                          </span>

                          {pickerData.map((data, ind) => (
                            <div className="color-picker" key={ind}>
                              <span className="mb-0 col-6 fs-14">
                                <svg
                                  className="me-2"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 14 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <rect
                                    width="14"
                                    height="14"
                                    rx="4"
                                    fill={data.fillcolor}
                                  />
                                </svg>

                                {data.datatitle}
                              </span>
                              <h5>${data.price}</h5>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 col-md-12">
              <div className="card">
                <div className="card-header border-0 pb-0">
                  <h2 className="heading mb-0">Earning Categories</h2>
                </div>
                <div className="card-body">
                  {/* Spot Earnings */}
                  <div className="d-flex mb-3">
                    <div className="icon-box bg-primary me-2 ">
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.0038 25.4285C11.7434 25.4285 9.53382 24.7582 7.6544 23.5024C5.77498 22.2466 4.31015 20.4617 3.44515 18.3734C2.58015 16.2851 2.35382 13.9872 2.7948 11.7703C3.23577 9.55337 4.32424 7.51699 5.92255 5.91868C7.52087 4.32036 9.55724 3.2319 11.7742 2.79092C13.9911 2.34995 16.289 2.57627 18.3773 3.44127C20.4656 4.30627 22.2505 5.7711 23.5063 7.65052C24.7621 9.52994 25.4323 11.7395 25.4323 13.9999C25.429 17.0299 24.2239 19.9349 22.0813 22.0774C19.9388 24.22 17.0338 25.4251 14.0038 25.4285ZM14.0038 4.85704C12.1955 4.85704 10.4278 5.39326 8.92427 6.39789C7.42074 7.40252 6.24887 8.83044 5.55687 10.5011C4.86487 12.1717 4.68381 14.01 5.03659 15.7836C5.38937 17.5571 6.26014 19.1862 7.5388 20.4649C8.81745 21.7435 10.4465 22.6143 12.2201 22.9671C13.9936 23.3199 15.832 23.1388 17.5026 22.4468C19.1732 21.7548 20.6011 20.5829 21.6058 19.0794C22.6104 17.5759 23.1466 15.8082 23.1466 13.9999C23.1439 11.5759 22.1798 9.25196 20.4657 7.53793C18.7517 5.8239 16.4278 4.85976 14.0038 4.85704Z"
                          fill="#FCFCFC"
                        ></path>
                        <path
                          d="M15.1466 18.5714H11.7181C11.4149 18.5714 11.1243 18.451 10.9099 18.2367C10.6956 18.0224 10.5752 17.7317 10.5752 17.4286C10.5752 17.1255 10.6956 16.8348 10.9099 16.6204C11.1243 16.4061 11.4149 16.2857 11.7181 16.2857H15.1466V15.1428H12.8609C12.2547 15.1428 11.6733 14.902 11.2447 14.4734C10.816 14.0447 10.5752 13.4633 10.5752 12.8571V11.7143C10.5752 11.1081 10.816 10.5267 11.2447 10.098C11.6733 9.66937 12.2547 9.42856 12.8609 9.42856H16.2895C16.5926 9.42856 16.8833 9.54897 17.0976 9.76329C17.3119 9.97762 17.4323 10.2683 17.4323 10.5714C17.4323 10.8745 17.3119 11.1652 17.0976 11.3795C16.8833 11.5939 16.5926 11.7143 16.2895 11.7143H12.8609V12.8571H15.1466C15.7528 12.8571 16.3342 13.0979 16.7629 13.5266C17.1915 13.9553 17.4323 14.5366 17.4323 15.1428V16.2857C17.4323 16.8919 17.1915 17.4733 16.7629 17.9019C16.3342 18.3306 15.7528 18.5714 15.1466 18.5714Z"
                          fill="#FCFCFC"
                        ></path>
                        <path
                          d="M14.0032 11.7142C13.7001 11.7142 13.4094 11.5937 13.1951 11.3794C12.9808 11.1651 12.8604 10.8744 12.8604 10.5713V9.42844C12.8604 9.12534 12.9808 8.83465 13.1951 8.62032C13.4094 8.40599 13.7001 8.28558 14.0032 8.28558C14.3063 8.28558 14.597 8.40599 14.8113 8.62032C15.0257 8.83465 15.1461 9.12534 15.1461 9.42844V10.5713C15.1461 10.8744 15.0257 11.1651 14.8113 11.3794C14.597 11.5937 14.3063 11.7142 14.0032 11.7142ZM14.0032 19.7142C13.7001 19.7142 13.4094 19.5937 13.1951 19.3794C12.9808 19.1651 12.8604 18.8744 12.8604 18.5713V17.4284C12.8604 17.1253 12.9808 16.8346 13.1951 16.6203C13.4094 16.406 13.7001 16.2856 14.0032 16.2856C14.3063 16.2856 14.597 16.406 14.8113 16.6203C15.0257 16.8346 15.1461 17.1253 15.1461 17.4284V18.5713C15.1461 18.8744 15.0257 19.1651 14.8113 19.3794C14.597 19.5937 14.3063 19.7142 14.0032 19.7142Z"
                          fill="#FCFCFC"
                        ></path>
                      </svg>
                    </div>
                    <div className="ps-2 w-100 flex-1">
                      <h6 className="">Spot Earnings</h6>
                      <div className="progress mt-2">
                        <div
                          className="progress-bar bg-primary"
                          style={{ width: `${calcProgress(earnings.spot)}%` }}
                        ></div>
                      </div>
                      <div className="mt-2">
                        <span>${earnings.spot.toFixed(2)}</span>
                        <span className="text-primary"> / from ${10000}</span>
                      </div>
                    </div>
                  </div>

                  {/* Future Earnings */}
                  <div className="d-flex mb-3">
                    <div className="icon-box bg-secondary me-2">
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.0038 25.4285C11.7434 25.4285 9.53382 24.7582 7.6544 23.5024C5.77498 22.2466 4.31015 20.4617 3.44515 18.3734C2.58015 16.2851 2.35382 13.9872 2.7948 11.7703C3.23577 9.55337 4.32424 7.51699 5.92255 5.91868C7.52087 4.32036 9.55724 3.2319 11.7742 2.79092C13.9911 2.34995 16.289 2.57627 18.3773 3.44127C20.4656 4.30627 22.2505 5.7711 23.5063 7.65052C24.7621 9.52994 25.4323 11.7395 25.4323 13.9999C25.429 17.0299 24.2239 19.9349 22.0813 22.0774C19.9388 24.22 17.0338 25.4251 14.0038 25.4285ZM14.0038 4.85704C12.1955 4.85704 10.4278 5.39326 8.92427 6.39789C7.42074 7.40252 6.24887 8.83044 5.55687 10.5011C4.86487 12.1717 4.68381 14.01 5.03659 15.7836C5.38937 17.5571 6.26014 19.1862 7.5388 20.4649C8.81745 21.7435 10.4465 22.6143 12.2201 22.9671C13.9936 23.3199 15.832 23.1388 17.5026 22.4468C19.1732 21.7548 20.6011 20.5829 21.6058 19.0794C22.6104 17.5759 23.1466 15.8082 23.1466 13.9999C23.1439 11.5759 22.1798 9.25196 20.4657 7.53793C18.7517 5.8239 16.4278 4.85976 14.0038 4.85704Z"
                          fill="#FCFCFC"
                        ></path>
                        <path
                          d="M15.1466 18.5714H11.7181C11.4149 18.5714 11.1243 18.451 10.9099 18.2367C10.6956 18.0224 10.5752 17.7317 10.5752 17.4286C10.5752 17.1255 10.6956 16.8348 10.9099 16.6204C11.1243 16.4061 11.4149 16.2857 11.7181 16.2857H15.1466V15.1428H12.8609C12.2547 15.1428 11.6733 14.902 11.2447 14.4734C10.816 14.0447 10.5752 13.4633 10.5752 12.8571V11.7143C10.5752 11.1081 10.816 10.5267 11.2447 10.098C11.6733 9.66937 12.2547 9.42856 12.8609 9.42856H16.2895C16.5926 9.42856 16.8833 9.54897 17.0976 9.76329C17.3119 9.97762 17.4323 10.2683 17.4323 10.5714C17.4323 10.8745 17.3119 11.1652 17.0976 11.3795C16.8833 11.5939 16.5926 11.7143 16.2895 11.7143H12.8609V12.8571H15.1466C15.7528 12.8571 16.3342 13.0979 16.7629 13.5266C17.1915 13.9553 17.4323 14.5366 17.4323 15.1428V16.2857C17.4323 16.8919 17.1915 17.4733 16.7629 17.9019C16.3342 18.3306 15.7528 18.5714 15.1466 18.5714Z"
                          fill="#FCFCFC"
                        ></path>
                        <path
                          d="M14.0032 11.7142C13.7001 11.7142 13.4094 11.5937 13.1951 11.3794C12.9808 11.1651 12.8604 10.8744 12.8604 10.5713V9.42844C12.8604 9.12534 12.9808 8.83465 13.1951 8.62032C13.4094 8.40599 13.7001 8.28558 14.0032 8.28558C14.3063 8.28558 14.597 8.40599 14.8113 8.62032C15.0257 8.83465 15.1461 9.12534 15.1461 9.42844V10.5713C15.1461 10.8744 15.0257 11.1651 14.8113 11.3794C14.597 11.5937 14.3063 11.7142 14.0032 11.7142ZM14.0032 19.7142C13.7001 19.7142 13.4094 19.5937 13.1951 19.3794C12.9808 19.1651 12.8604 18.8744 12.8604 18.5713V17.4284C12.8604 17.1253 12.9808 16.8346 13.1951 16.6203C13.4094 16.406 13.7001 16.2856 14.0032 16.2856C14.3063 16.2856 14.597 16.406 14.8113 16.6203C15.0257 16.8346 15.1461 17.1253 15.1461 17.4284V18.5713C15.1461 18.8744 15.0257 19.1651 14.8113 19.3794C14.597 19.5937 14.3063 19.7142 14.0032 19.7142Z"
                          fill="#FCFCFC"
                        ></path>
                      </svg>
                    </div>
                    <div className="ps-2 w-100 flex-1">
                      <h6 className="">Future Earnings</h6>
                      <div className="progress mt-2">
                        <div
                          className="progress-bar bg-secondary"
                          style={{ width: `${calcProgress(earnings.future)}%` }}
                        ></div>
                      </div>
                      <div className="mt-2">
                        <span>${earnings.future.toFixed(2)}</span>
                        <span className="text-primary"> / from ${10000}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* your balance section */}
        {/* <div className="col-xl-6 col-lg-6 col-sm-6">
          <div className="card exchange">
            <div className="card-header d-block border-0 pb-0">
              <h2 className="heading"> Your Balance</h2>
            </div>
            <div className="card-body pt-0">
              <div className="balance">
                <div className="header-content">
                  <h6 className="text-muted">$23,741.60</h6>
                </div>
                <div className="d-flex justify-content-between align-items-baseline">
                  <h4 className="count-num">$23,741.60</h4>
                  <span className="fs-14 font-w400 text-success">
                    <i className="bi bi-caret-up-fill pe-2"></i>+ 15%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <BalanceCard
          summary={walletSummary}
          refresh={async () => {
            const [summary, buyRes, sellRes] = await Promise.all([
              getWalletTransactionsSummary().catch(() => null),
              getWalletTransactions({ type: "buy" }).catch(() => null),
              getWalletTransactions({ type: "sell" }).catch(() => null),
            ]);
            if (summary) setWalletSummary(summary);
            setBuySummary(buyRes?.data?.data ?? []);
            setSellSummary(sellRes?.data?.data ?? []);
          }}
        />
        {/* incine, outcome earning categories */}
        <div className="col-xl-6">
          <div className="row">
            {cardTitle.map((item, ind) => (
              <div className="" key={ind}>
                <div className="card">
                  <div className="card-header border-0 pb-0">
                    <h2 className="heading mb-0 m-auto">{item.title}</h2>
                  </div>
                  <div className="card-body text-center pt-3">
                    <div className="icon-box bg-primary">
                      {item.title === "Income" && (
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9 30H23C24.3261 30 25.5979 29.4732 26.5355 28.5355C27.4732 27.5979 28 26.3261 28 25V19C28 17.6739 27.4732 16.4021 26.5355 15.4645C25.5979 14.5268 24.3261 14 23 14H9C7.67392 14 6.40215 14.5268 5.46447 15.4645C4.52678 16.4021 4 17.6739 4 19V25C4 26.3261 4.52678 27.5979 5.46447 28.5355C6.40215 29.4732 7.67392 30 9 30ZM6 19C6 18.2044 6.31607 17.4413 6.87868 16.8787C7.44129 16.3161 8.20435 16 9 16H23C23.7956 16 24.5587 16.3161 25.1213 16.8787C25.6839 17.4413 26 18.2044 26 19V25C26 25.7956 25.6839 26.5587 25.1213 27.1213C24.5587 27.6839 23.7956 28 23 28H9C8.20435 28 7.44129 27.6839 6.87868 27.1213C6.31607 26.5587 6 25.7956 6 25V19Z"
                            fill="white"
                          />

                          <path
                            d="M16 26C16.7912 26 17.5645 25.7654 18.2223 25.3259C18.8801 24.8864 19.3928 24.2616 19.6955 23.5307C19.9983 22.7998 20.0775 21.9956 19.9232 21.2196C19.7688 20.4437 19.3879 19.731 18.8285 19.1716C18.269 18.6122 17.5563 18.2312 16.7804 18.0769C16.0045 17.9225 15.2002 18.0017 14.4693 18.3045C13.7384 18.6072 13.1137 19.1199 12.6741 19.7777C12.2346 20.4355 12 21.2089 12 22C12 23.0609 12.4215 24.0783 13.1716 24.8284C13.9217 25.5786 14.9392 26 16 26ZM16 20C16.3956 20 16.7823 20.1173 17.1112 20.3371C17.4401 20.5568 17.6964 20.8692 17.8478 21.2346C17.9992 21.6001 18.0388 22.0022 17.9616 22.3902C17.8844 22.7781 17.6939 23.1345 17.4142 23.4142C17.1345 23.6939 16.7782 23.8844 16.3902 23.9616C16.0022 24.0387 15.6001 23.9991 15.2347 23.8478C14.8692 23.6964 14.5569 23.44 14.3371 23.1111C14.1173 22.7822 14 22.3956 14 22C14 21.4696 14.2107 20.9609 14.5858 20.5858C14.9609 20.2107 15.4696 20 16 20Z"
                            fill="white"
                          />

                          <path
                            d="M16 2C15.7348 2 15.4805 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3V8.59L12.46 6.05C12.2687 5.88617 12.0227 5.80057 11.771 5.81029C11.5193 5.82001 11.2806 5.92434 11.1025 6.10244C10.9244 6.28053 10.82 6.51927 10.8103 6.77095C10.8006 7.02262 10.8862 7.2687 11.05 7.46L15.29 11.71C15.3822 11.8 15.4908 11.8713 15.61 11.92C15.7334 11.9723 15.866 11.9992 16 11.9992C16.134 11.9992 16.2666 11.9723 16.39 11.92C16.5092 11.8713 16.6179 11.8 16.71 11.71L21 7.46C21.1639 7.2687 21.2495 7.02262 21.2397 6.77095C21.23 6.51927 21.1257 6.28053 20.9476 6.10244C20.7695 5.92434 20.5308 5.82001 20.2791 5.81029C20.0274 5.80057 19.7813 5.88617 19.59 6.05L17 8.59V3C17 2.73478 16.8947 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2Z"
                            fill="white"
                            transform="translate(0,0)"
                          />
                        </svg>
                      )}
                      {item.title === "Outcome" && (
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9 30H23C24.3261 30 25.5979 29.4732 26.5355 28.5355C27.4732 27.5979 28 26.3261 28 25V19C28 17.6739 27.4732 16.4021 26.5355 15.4645C25.5979 14.5268 24.3261 14 23 14H9C7.67392 14 6.40215 14.5268 5.46447 15.4645C4.52678 16.4021 4 17.6739 4 19V25C4 26.3261 4.52678 27.5979 5.46447 28.5355C6.40215 29.4732 7.67392 30 9 30ZM6 19C6 18.2044 6.31607 17.4413 6.87868 16.8787C7.44129 16.3161 8.20435 16 9 16H23C23.7956 16 24.5587 16.3161 25.1213 16.8787C25.6839 17.4413 26 18.2044 26 19V25C26 25.7956 25.6839 26.5587 25.1213 27.1213C24.5587 27.6839 23.7956 28 23 28H9C8.20435 28 7.44129 27.6839 6.87868 27.1213C6.31607 26.5587 6 25.7956 6 25V19Z"
                            fill="white"
                          />

                          <path
                            d="M16 26C16.7912 26 17.5645 25.7654 18.2223 25.3259C18.8801 24.8864 19.3928 24.2616 19.6955 23.5307C19.9983 22.7998 20.0775 21.9956 19.9232 21.2196C19.7688 20.4437 19.3879 19.731 18.8285 19.1716C18.269 18.6122 17.5563 18.2312 16.7804 18.0769C16.0045 17.9225 15.2002 18.0017 14.4693 18.3045C13.7384 18.6072 13.1137 19.1199 12.6741 19.7777C12.2346 20.4355 12 21.2089 12 22C12 23.0609 12.4215 24.0783 13.1716 24.8284C13.9217 25.5786 14.9392 26 16 26ZM16 20C16.3956 20 16.7823 20.1173 17.1112 20.3371C17.4401 20.5568 17.6964 20.8692 17.8478 21.2346C17.9992 21.6001 18.0388 22.0022 17.9616 22.3902C17.8844 22.7781 17.6939 23.1345 17.4142 23.4142C17.1345 23.6939 16.7782 23.8844 16.3902 23.9616C16.0022 24.0387 15.6001 23.9991 15.2347 23.8478C14.8692 23.6964 14.5569 23.44 14.3371 23.1111C14.1173 22.7822 14 22.3956 14 22C14 21.4696 14.2107 20.9609 14.5858 20.5858C14.9609 20.2107 15.4696 20 16 20Z"
                            fill="white"
                          />

                          <path
                            d="M16 2C15.7348 2 15.4805 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3V8.59L12.46 6.05C12.2687 5.88617 12.0227 5.80057 11.771 5.81029C11.5193 5.82001 11.2806 5.92434 11.1025 6.10244C10.9244 6.28053 10.82 6.51927 10.8103 6.77095C10.8006 7.02262 10.8862 7.2687 11.05 7.46L15.29 11.71C15.3822 11.8 15.4908 11.8713 15.61 11.92C15.7334 11.9723 15.866 11.9992 16 11.9992C16.134 11.9992 16.2666 11.9723 16.39 11.92C16.5092 11.8713 16.6179 11.8 16.71 11.71L21 7.46C21.1639 7.2687 21.2495 7.02262 21.2397 6.77095C21.23 6.51927 21.1257 6.28053 20.9476 6.10244C20.7695 5.92434 20.5308 5.82001 20.2791 5.81029C20.0274 5.80057 19.7813 5.88617 19.59 6.05L17 8.59V3C17 2.73478 16.8947 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2Z"
                            fill="white"
                            transform="rotate(180 16 7)"
                          />
                        </svg>
                      )}
                    </div>
                    <div className="mt-3">Last Month</div>
                    <div className="count-num mt-1">
                      {" "}
                      $
                      {item.title === "Income"
                        ? walletSummary.income
                        : walletSummary.outcome}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* buy and sell from home/dashboard ==>*/}
        <div className="Container-fluid">
          <div className="row">
            <div className="col-12 col-xl-6">
              <div className="card">
                <div className="card-header">
                  <h4 className="heading">Deposit</h4>
                  {/* <span>Total: 409.2820</span> */}
                </div>
                <div className="card-body pt-0 px-0">
                  <div className="table-responsive buy-sell-table">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Amount</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {buySummary?.map((item, ind) => (
                          <tr key={ind}>
                            <td>{Number(item?.quantity).toFixed(4)}</td>
                            <td>
                              {new Date(item?.createdAt).toLocaleString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer text-center p-0 border-0">
                    <Link to="/funds-history" className="btn-link text-black">
                      Show more <i className="fa fa-caret-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {/* buy ==> */}
            <div className="col-12 col-xl-6">
              <div className="card sell-bg-tbl">
                <div className="card-header">
                  <h4 className="heading">Withdraw</h4>
                  {/* <span>Total: 409.2820</span> */}
                </div>
                <div className="card-body pt-0 px-0">
                  <div className="table-responsive buy-sell-table">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Amount</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sellSummary.map((item, ind) => (
                          <tr key={ind}>
                            <td>{Number(item?.quantity).toFixed(4)}</td>
                            <td>
                              {new Date(item?.createdAt).toLocaleString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer text-center p-0 border-0">
                    <Link to="/funds-history" className="btn-link text-black">
                      Show more <i className="fa fa-caret-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Portfolio;
